import { render, staticRenderFns } from "./SwipedHomeBanner.vue?vue&type=template&id=30aed1b2&scoped=true&"
import script from "./SwipedHomeBanner.vue?vue&type=script&lang=js&"
export * from "./SwipedHomeBanner.vue?vue&type=script&lang=js&"
import style0 from "./SwipedHomeBanner.vue?vue&type=style&index=0&id=30aed1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aed1b2",
  null
  
)

export default component.exports